import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
 
  TrendingUp,
  
  Shield,
  Banknote,

  AlertTriangle,
  Heart,
  Building,
  BarChart3,

} from 'lucide-react';
import { useNavigation } from '../hooks/useNavigation';
// ייבוא ה-API החדש
import api from '../services/api';
import RouteScannerCTA from '../components/RouteScannerCTA';
import MultipleComparisonTables, { CompactComparisonTable } from '../components/CompactComparisonTable';
// import CategoryButtons from '../components/CategoryButtons';
import { getSpecializationConfigs } from '../config/fundConfigurations';
// הוסף את השורה הזו עם שאר הייבואים בתחילת הקובץ
import CategoryInfoSection from '../components/CategoryInfoSection';
import Header from '../components/Header';
// הוסף את השורה הזו עם שאר הייבואים
import preloader from '../services/preloader';
import LazyComparisonTable from '../components/LazyComparisonTable';
import SpecializationButtons from '../components/SpecializationButtons';

const NewHomePage = ({ defaultCategory = null }) => {
  const navigate = useNavigate();
    const { category: urlCategory } = useParams();
  const { 
    handleCategoryChange, 
    goToHomePage, 
    shouldScrollToContent, 
    setShouldScrollToContent, 
    savingsCategories 
  } = useNavigation();


  const headerRef = useRef(null);
  // קביעת הקטגוריה הנבחרת לפי URL או defaultCategory
  const [selectedCategory, setSelectedCategory] = useState(
    urlCategory || defaultCategory || null
  );
  const [topProducts, setTopProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statistics, setStatistics] = useState(null);
  const [currentSearchTerm, setCurrentSearchTerm] = useState(''); // לשמירת מונח החיפוש הנוכחי
// הוסף את השורה הזו עם שאר ה-useState
const [preloadStatus, setPreloadStatus] = useState({ progress: 0 });
  // 6 קטגוריות מוצרי החיסכון עם URLs
const [selectedSpecialization, setSelectedSpecialization] = useState(null);




const handleSpecializationClick = (specializationKey) => {
  // אם לוחצים על אותו כפתור - בטל בחירה
  if (selectedSpecialization === specializationKey) {
    setSelectedSpecialization(null);
    return;
  }
  
  setSelectedSpecialization(specializationKey);
  
  console.log(`🎯 Clicked on: ${specializationKey}`);
  
  // 🔥 פתרון פשוט ויעיל: גלול למיקום משוער + תן לדף להסתדר
  const scrollToEstimatedPosition = () => {
    const specializations = getSpecializationConfigs(selectedCategory);
    const targetIndex = specializations.findIndex(spec => spec.key === specializationKey);
    
    if (targetIndex === -1) {
      console.error('❌ Specialization not found');
      return;
    }
    
    const isMobile = window.innerWidth < 768;
    const buttonBar = document.getElementById('specialization-buttons-bar');
    const buttonBarHeight = buttonBar?.offsetHeight || 60;
    
    // חשב מיקום משוער
    const estimatedTableHeight = isMobile ? 900 : 700;
    const headerOffset = isMobile ? 300 : 400;
    const spacing = 50; // מרווח בין טבלאות
    const estimatedPosition = headerOffset + (targetIndex * (estimatedTableHeight + spacing));
    
    // התאם את המיקום לפי גודל המסך
    const offset = isMobile ? buttonBarHeight + 20 : buttonBarHeight + 80;
    const targetScroll = Math.max(0, estimatedPosition - offset);
    
    console.log(`📍 Scrolling to estimated position:`, {
      specializationKey,
      targetIndex,
      isMobile,
      estimatedPosition,
      offset,
      targetScroll
    });
    
    window.scrollTo({
      top: targetScroll,
      behavior: 'smooth'
    });
    
    // 🎯 אחרי הגלילה, נסה למצוא את הטבלה האמיתית ולכוונן
    let attempts = 0;
    const maxAttempts = 8; // רק 8 ניסיונות = 2.4 שניות
    
    const finetuneScroll = () => {
      attempts++;
      const tableElement = document.getElementById(`table-${specializationKey}`);
      
      if (tableElement && tableElement.offsetHeight > 100) {
        // ✅ מצאנו טבלה טעונה - כוונן את המיקום
        const rect = tableElement.getBoundingClientRect();
        const scrollY = window.pageYOffset;
        const tableAbsoluteTop = scrollY + rect.top;
        const currentOffset = isMobile ? buttonBarHeight + 20 : buttonBarHeight + 80;
        const perfectScroll = Math.max(0, tableAbsoluteTop - currentOffset);
        
        // רק אם ההפרש משמעותי (יותר מ-50px), תקן
        if (Math.abs(scrollY - perfectScroll) > 50) {
          console.log(`✅ Fine-tuning scroll (attempt ${attempts}):`, {
            currentScroll: scrollY,
            perfectScroll,
            difference: Math.abs(scrollY - perfectScroll)
          });
          
          window.scrollTo({
            top: perfectScroll,
            behavior: 'smooth'
          });
        } else {
          console.log(`✅ Scroll position is good enough (attempt ${attempts})`);
        }
        return;
      }
      
      // אם עדיין לא מצאנו, נסה שוב
      if (attempts < maxAttempts) {
        setTimeout(finetuneScroll, 300);
      } else {
        console.log(`⚠️ Stopped after ${attempts} attempts - table might not be loaded yet`);
      }
    };
    
    // התחל כיוונון אחרי שהגלילה הראשונה הסתיימה
    setTimeout(finetuneScroll, 1000);
  };
  
  // התחל את התהליך
  setTimeout(scrollToEstimatedPosition, 100);
};
// איפוס ההתמחות הנבחרת כשמשנים קטגוריה
useEffect(() => {
  setSelectedSpecialization(null);
}, [selectedCategory]);
  const currentCategory = savingsCategories.find(cat => cat.id === selectedCategory);
useEffect(() => {
  // גלול תמיד כשיש קטגוריה נבחרת (לא רק כש-shouldScrollToContent=true)
  if (selectedCategory && headerRef.current) {
    setTimeout(() => {
      const headerHeight = headerRef.current.offsetHeight;
      window.scrollTo({
        top: headerHeight + 20,
        left: 0,
        behavior: 'smooth'
      });
    }, 1500);
  }
}, [selectedCategory]); // הסר את shouldScrollToContent מהתלות
  // עדכון הקטגוריה כאשר URL משתנה
  useEffect(() => {
    if (urlCategory !== selectedCategory) {
      setSelectedCategory(urlCategory);
      setTopProducts([]);
      setError(null);
      setCurrentSearchTerm('');
    }
  }, [urlCategory]);

  // טעינת סטטיסטיקות כלליות בטעינה ראשונית
  useEffect(() => {
    const loadStatistics = async () => {
      try {
        const stats = await api.getStatistics();
        setStatistics(stats);
      
      } catch (error) {
        console.error('❌ Error loading statistics:', error);
      }
    };

    loadStatistics();
  }, []);

  // טיפול בתוצאות החיפוש מ-SearchAutocomplete
  const handleSearchResults = (results, searchTerm, error = null) => {
    setLoading(false);
    setCurrentSearchTerm(searchTerm || '');
    
    if (error) {
      console.error(`❌ Search error for "${searchTerm}":`, error);
      setError(`שגיאה בחיפוש: ${error}`);
      setTopProducts([]);
      return;
    }
  
    if (results.length === 0) {
    
      setError(`לא נמצאו תוצאות עבור "${searchTerm}"${selectedCategory ? ` בקטגוריה ${currentCategory?.title}` : ''}`);
      setTopProducts([]);
      return;
    }
  
    
  
    // אם התוצאות כבר מעובדות (מהחיפוש החדש), השתמש בהן ישירות
    if (results[0]?.returns) {
      setTopProducts(results);
    } else {
      // המרת התוצאות הגולמיות (למקרה של תוצאות ישנות)
      const transformedResults = results.map(item => ({
        id: item.FUND_ID?.toString() || '',
        name: item.FUND_NAME || 'שם לא זמין',
        company: item.PARENT_COMPANY_NAME || 
                 item.MANAGING_CORPORATION || 
                 item.CONTROLLING_CORPORATION || 
                 'חברה לא ידועה',
        
        source: item._source || 'unknown',
        sourceLabel: item._sourceLabel || 'לא ידוע',
        
        returns: {
          month1: parseFloat(item.MONTHLY_YIELD) || 0,
          year1: parseFloat(item.YEAR_TO_DATE_YIELD) || 0,
          year3: parseFloat(item.YIELD_TRAILING_3_YRS) || 0,
          year5: parseFloat(item.YIELD_TRAILING_5_YRS) || 0
        },
        
        fees: {
          management: parseFloat(item.AVG_ANNUAL_MANAGEMENT_FEE) || 0,
          deposit: parseFloat(item.AVG_DEPOSIT_FEE) || 0
        },
        
        totalAssets: (parseFloat(item.TOTAL_ASSETS) || 0) * 1000000,
        classification: item.FUND_CLASSIFICATION || '',
        
        exposures: {
          stocks: parseFloat(item.STOCK_MARKET_EXPOSURE) || 0,
          foreign: parseFloat(item.FOREIGN_EXPOSURE) || 0,
          currency: parseFloat(item.FOREIGN_CURRENCY_EXPOSURE) || 0
        },
        
        reportPeriod: item.REPORT_PERIOD?.toString() || '',
        isRealData: true,
        lastUpdate: new Date().toISOString()
      }));
  
      setTopProducts(transformedResults);
    }
    
    setError(null);
    
    // הצגת מקורות הנתונים
    const sources = [...new Set(results.map(r => r.sourceLabel || r._sourceLabel))].filter(Boolean);

  };
// הוסף פונקציות:
const getProductCategory = (product) => {
  const source = product.source || product._source;
  switch (source) {
    case 'gamal-net':
      if (product.name?.includes('השתלמות')) return 'study-funds';
      if (product.name?.includes('ילד')) return 'child-savings';
      if (product.classification?.includes('השקעה')) return 'investment-funds';
      return 'pension-savings';
    case 'pension-net': return 'pension-plans';
    case 'insurance-net': return 'insurance-savings';
    default: return selectedCategory || 'study-funds';
  }
};

const openProductDetails = (product) => {
  const productCategory = selectedCategory || getProductCategory(product);
  navigate(`/product/${productCategory}/${product.id}`);
};




  // עדכון הטייטל של הדף כאשר הקטגוריה משתנה
  useEffect(() => {
    if (currentCategory) {
      document.title = `השוואת ${currentCategory.title} | מערכת השוואת מוצרי חיסכון`;
    } else {
      document.title = 'השוואת מוצרי חיסכון | נתונים אמיתיים מהממשלה';
    }
  }, [currentCategory]);
useEffect(() => {
  // 🛡️ מנע הרצה כפולה
  if (preloader.isPreloading) {
    console.log('⏭️ Preload already running, skipping...');
    return;
  }
  
  
  preloader.startAutoPreload();
  
  const progressInterval = setInterval(() => {
    const status = preloader.getPreloadStatus();
    setPreloadStatus(status);
    
    if (status.progress >= 100) {
      clearInterval(progressInterval);
      console.log('🎉 Preload completed!');
    }
  }, 500);

  return () => clearInterval(progressInterval);
}, []);
  
// דיבוג - הוסף את זה לתחילת NewHomePage כדי לבדוק מה קורה:


  return (
<div className="pt-8 md:pt-14" style={{ margin: 0, padding: 0 }}>
  {/* {preloadStatus.progress > 0 && preloadStatus.progress < 100 && (
  <div className="fixed top-0 left-0 right-0 bg-blue-600 text-white text-center py-1 text-sm z-50">
    טוען נתונים... {preloadStatus.progress}%
    <div className="absolute bottom-0 left-0 bg-blue-400 h-1 transition-all duration-300" 
         style={{ width: `${preloadStatus.progress}%` }}></div>
  </div>
)} */}
    <Header 
    ref={headerRef}
  selectedCategory={selectedCategory}
      currentCategory={currentCategory}
      savingsCategories={savingsCategories}
      goToHomePage={goToHomePage}
      handleCategoryChange={handleCategoryChange}
      handleSearchResults={handleSearchResults}
      loading={loading}
      currentSearchTerm={currentSearchTerm}
      statistics={statistics}
    />
    {/* 🆕 שורת כפתורי התמחויות - רק כשיש קטגוריה נבחרת */}
{selectedCategory && !currentSearchTerm && (
  <SpecializationButtons
    category={selectedCategory}
    selectedSpecialization={selectedSpecialization}
    onSpecializationClick={handleSpecializationClick}
  />
)}
{/* {!selectedCategory && !currentSearchTerm && (
  <CategoryButtons />
)} */}

      {/* תוצאות חיפוש */}
      {currentSearchTerm && topProducts.length > 0 && (
        <section className=" bg-white mt-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                תוצאות חיפוש עבור "{currentSearchTerm}"
              </h2>
              <p className="text-gray-600">
                נמצאו {topProducts.length} תוצאות
                {selectedCategory && ` בקטגוריה ${currentCategory?.title}`}
              </p>
              
              {/* מקורות הנתונים */}
              <div className="flex justify-center gap-4 mt-4">
                {[...new Set(topProducts.map(p => p.sourceLabel))].map(source => (
                  <span key={source} className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
                    {source}
                  </span>
                ))}
              </div>
            </div>

            {/* רשת תוצאות */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {topProducts.map((product, index) => (
                <div key={`${product.source}-${product.id}-${index}`} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                  
                  {/* כותרת עם מקור */}
                  <div className="flex justify-between items-start mb-4">
                    <div className="flex-1">
                      <h3 className="font-bold text-lg text-gray-900 mb-1 leading-tight">
                        {product.name}
                      </h3>
                      <p className="text-sm text-gray-600">{product.company}</p>
                      <div className="flex items-center gap-2 mt-2">
                        <span className="text-xs bg-gray-100 px-2 py-1 rounded">
                         מספר באוצר: {product.id}
                        </span>
                        <span className={`text-xs px-2 py-1 rounded text-white ${
                          product.source === 'gamal-net' ? 'bg-blue-500' :
                          product.source === 'pension-net' ? 'bg-green-500' :
                          product.source === 'insurance-net' ? 'bg-orange-500' : 'bg-gray-500'
                        }`}>
                          {product.sourceLabel}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* תשואות */}
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="text-center p-3 bg-blue-50 rounded">
                      <div className="text-xs text-gray-600">תשואה שנתית</div>
                      <div className={`text-lg font-bold ${
                        (product.returns?.year1 || 0) >= 0 ? 'text-blue-600' : 'text-red-600'
                      }`}>
                        {(product.returns?.year1 || 0).toFixed(2)}%
                      </div>
                    </div>
                    <div className="text-center p-3 bg-purple-50 rounded">
                      <div className="text-xs text-gray-600">3 שנים</div>
                      <div className={`text-lg font-bold ${
                        (product.returns?.year3 || 0) >= 0 ? 'text-purple-600' : 'text-red-600'
                      }`}>
                        {(product.returns?.year3 || 0).toFixed(2)}%
                      </div>
                    </div>
                  </div>

                  {/* עלויות */}
                  <div className="flex justify-between items-center mb-4 p-3 bg-gray-50 rounded">
                    <span className="text-sm text-gray-600">דמי ניהול</span>
                    <span className="font-medium text-gray-900">
                      {(product.fees?.management || 0).toFixed(2)}%
                    </span>
                  </div>

                  {/* כפתור פרטים */}
                  <button
                    onClick={() => openProductDetails(product)}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg text-sm font-medium transition-colors"
                  >
                    צפה בפרטים מלאים
                  </button>
                </div>
              ))}
            </div>

            {/* כפתור לניקוי חיפוש */}
            <div className="text-center mt-8">
              <button
                onClick={() => {
                  setCurrentSearchTerm('');
                  setTopProducts([]);
                  setError(null);
                }}
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-2 rounded-lg text-sm font-medium"
              >
                נקה חיפוש
              </button>
            </div>
          </div>
        </section>
      )}

      {/* הצגת שגיאות חיפוש */}
      {error && (
        <section className="py-8 bg-red-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="inline-flex items-center px-4 py-2 bg-red-100 text-red-800 rounded-lg">
                <AlertTriangle className="h-5 w-5 mr-2" />
                {error}
              </div>
            </div>
          </div>
        </section>
      )}


{selectedCategory && !currentSearchTerm && (
  <>
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <MultipleComparisonTables 
          key={selectedCategory} // 🆕 זה הקסם! כשהקטגוריה משתנה, הקומפוננט "נולד מחדש"
          category={selectedCategory}
          categoryTitle={currentCategory?.title}
        />
      </div>
    </section>
    {/* 🆕 הוסף את זה כאן */}
    <RouteScannerCTA />
    {/* 🆕 סקציית מידע לפי קטגוריה */}
    <CategoryInfoSection   key={`${selectedCategory}-info`} selectedCategory={selectedCategory} currentCategory={currentCategory} />
  </>
)}
      {/* טבלאות השוואה כשאין קטגוריה נבחרת */}
      {!selectedCategory && !currentSearchTerm && (
 <section className="pt-6 pb-12 bg-white">


    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          טבלאות השוואה מובילות
        </h2>
        <p className="text-xl text-gray-600">
          נתונים אמיתיים ממקורות ממשלתיים - גמל-נט, פנסיה-נט וביטוח-נט
        </p>
      </div> */}

      {/* טבלאות דוגמה לכל נושא */}
      <div className="space-y-16">
        
        {/* 📈 קרנות השתלמות */}
        <div className="bg-white rounded-2xl p-4 md:p-8 border border-blue-200">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-4 mb-4 md:mb-6">
  {/* טקסט ואייקון */}
  <div className="flex items-start gap-2 md:gap-4">
    <div className="p-2 md:p-3 bg-blue-500 rounded-xl shadow-md">
      <BarChart3 className="h-4 w-4 md:h-6 md:w-6 text-white" />
    </div>
    <div className="text-right">
      <h3 className="text-base md:text-2xl font-bold text-gray-900">קרנות השתלמות</h3>
      <p className="text-xs md:text-base text-blue-600 font-medium">גמל-נט • זכאות להטבות מס</p>
    </div>
  </div>

  {/* כפתור פעולה */}
  <div className="self-end md:self-auto w-full md:w-auto">
    <button
      onClick={() => handleCategoryChange('study-funds')}
      className="w-full md:w-auto px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-base bg-blue-600 hover:bg-blue-700 text-white rounded-lg md:rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
    >
      צפה בכל הקרנות ←
    </button>
  </div>
</div>

          
          {/* שתי טבלאות דוגמה - כללי ו-S&P 500 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LazyComparisonTable
            
              category="study-funds"
          
              title={getSpecializationConfigs('study-funds', 'קרנות השתלמות').find(spec => spec.key === 'כללי')?.title || "קרנות השתלמות - כללי"}
              fundIds={getSpecializationConfigs('study-funds').find(spec => spec.key === 'כללי')?.fundIds || []}
              specialization="כללי"
            />
            <LazyComparisonTable
              category="study-funds"
         
              title={getSpecializationConfigs('study-funds', 'קרנות השתלמות').find(spec => spec.key === 'sp500')?.title || "קרנות השתלמות - S&P 500"}
              fundIds={getSpecializationConfigs('study-funds').find(spec => spec.key === 'sp500')?.fundIds || []}
              specialization="sp500"
            />
          </div>
        </div>

        {/* 💰 קופות גמל */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-4 md:p-8 border border-green-200">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-4 mb-4 md:mb-6">
          <div className="flex items-start gap-2 md:gap-4">
            <div className="p-2 md:p-3 bg-green-500 rounded-xl shadow-md">
              <Banknote className="h-4 w-4 md:h-6 md:w-6 text-white" />
            </div>
            <div className="text-right">
              <h3 className="text-base md:text-2xl font-bold text-gray-900">קופות גמל</h3>
              <p className="text-xs md:text-base text-green-600 font-medium">גמל-נט • פיצויים ותגמולים</p>
            </div>
          </div>
          <div className="self-end md:self-auto w-full md:w-auto">
            <button
              onClick={() => handleCategoryChange('pension-savings')}
              className="w-full md:w-auto px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-base bg-green-600 hover:bg-green-700 text-white rounded-lg md:rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
            >
             צפה בכל הקופות ←
            </button>
          </div>
        </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LazyComparisonTable
              category="pension-savings"
              
              title={getSpecializationConfigs('pension-savings', 'קופות גמל').find(spec => spec.key === 'sp500-גמל')?.title || "קופות גמל - S&P 500"}
              fundIds={getSpecializationConfigs('pension-savings').find(spec => spec.key === 'sp500-גמל')?.fundIds || []}
              specialization="sp500-גמל"
            />
            <LazyComparisonTable
              category="pension-savings"
              
              title={getSpecializationConfigs('pension-savings', 'קופות גמל').find(spec => spec.key === 'עד-50')?.title || "קופות גמל - עד גיל 50"}
              fundIds={getSpecializationConfigs('pension-savings').find(spec => spec.key === 'עד-50')?.fundIds || []}
              specialization="עד-50"
            />
          </div>
        </div>

        {/* 📊 קופות גמל להשקעה */}
        <div className="bg-gradient-to-br from-purple-50 to-violet-50 rounded-2xl p-4 md:p-8 border border-purple-200">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-4 mb-4 md:mb-6">
          <div className="flex items-start gap-2 md:gap-4">
            <div className="p-2 md:p-3 bg-purple-500 rounded-xl shadow-md">
              <TrendingUp className="h-4 w-4 md:h-6 md:w-6 text-white" />
            </div>
            <div className="text-right">
              <h3 className="text-base md:text-2xl font-bold text-gray-900">קופות גמל להשקעה</h3>
              <p className="text-xs md:text-base text-purple-600 font-medium">גמל-נט • השקעות ארוכות טווח</p>
            </div>
          </div>
          <div className="self-end md:self-auto w-full md:w-auto">
            <button
              onClick={() => handleCategoryChange('investment-funds')}
              className="w-full md:w-auto px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-base bg-purple-600 hover:bg-purple-700 text-white rounded-lg md:rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
            >
             צפה בכל הקופות ←
            </button>
          </div>
        </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LazyComparisonTable
              category="investment-funds"
             
              title={getSpecializationConfigs('investment-funds', 'קופות גמל להשקעה').find(spec => spec.key === 'כללי-השקעה')?.title || "גמל השקעה - כללי"}
              fundIds={getSpecializationConfigs('investment-funds').find(spec => spec.key === 'כללי-השקעה')?.fundIds || []}
              specialization="כללי-השקעה"
            />
            <LazyComparisonTable
              category="investment-funds"
           
              title={getSpecializationConfigs('investment-funds', 'קופות גמל להשקעה').find(spec => spec.key === 'sp500-השקעה')?.title || "גמל השקעה - S&P 500"}
              fundIds={getSpecializationConfigs('investment-funds').find(spec => spec.key === 'sp500-השקעה')?.fundIds || []}
              specialization="sp500-השקעה"
            />
          </div>
        </div>

        {/* 🛡️ פוליסות חיסכון */}
        <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 md:p-8 border border-orange-200">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="p-2.5 md:p-3 bg-orange-500 rounded-xl shadow-md">
              <Shield className="h-5 w-5 md:h-6 md:w-6 text-white" />
            </div>
            <div className="text-right">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">פוליסות חיסכון</h3>
              <p className="text-sm sm:text-base text-orange-600 font-medium">ביטוח-נט • ביטוח וחיסכון משולב</p>
            </div>
          </div>
          <div className="self-end md:self-auto">
            <button
              onClick={() => handleCategoryChange('insurance-savings')}
              className="px-4 py-2 text-sm sm:text-base bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
            >
               צפה בכל הפוליסות ←
            </button>
          </div>
        </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LazyComparisonTable
              category="insurance-savings"
               
              title={getSpecializationConfigs('insurance-savings', 'פוליסות חיסכון').find(spec => spec.key === 'כללי')?.title || "פוליסות חיסכון - כללי"}
              fundIds={getSpecializationConfigs('insurance-savings').find(spec => spec.key === 'כללי')?.fundIds || []}
              specialization="כללי"
            />
            <LazyComparisonTable
              category="insurance-savings"
               
              title={getSpecializationConfigs('insurance-savings', 'פוליסות חיסכון').find(spec => spec.key === 'sp500')?.title || "פוליסות חיסכון - S&P 500"}
              fundIds={getSpecializationConfigs('insurance-savings').find(spec => spec.key === 'sp500')?.fundIds || []}
              specialization="sp500"
            />
          </div>
        </div>
{/* ביטוח מנהלים */}
<div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 md:p-8 border border-teal-200">
  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
    <div className="flex items-start gap-3 md:gap-4">
      <div className="p-2.5 md:p-3 bg-teal-500 rounded-xl shadow-md">
        <Building className="h-5 w-5 md:h-6 md:w-6 text-white" />
      </div>
      <div className="text-right">
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">קרנות ביטוח מנהלים</h3>
        <p className="text-sm sm:text-base text-teal-600 font-medium">ביטוח-נט • קרנות השקעה של חברות ביטוח</p>
      </div>
    </div>
    <div className="self-end md:self-auto">
      <button
        onClick={() => handleCategoryChange('insurance-management')}
        className="px-4 py-2 text-sm sm:text-base bg-teal-600 hover:bg-teal-700 text-white rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
      >
        צפה בכל הקרנות ←
      </button>
    </div>
  </div>
  
<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
  <LazyComparisonTable
    category="insurance-management"
 
    title={getSpecializationConfigs('insurance-management', 'קרנות ביטוח מנהלים').find(spec => spec.key === '50-60')?.title || "קרנות ביטוח מנהלים - לבני 50-60"}
    fundIds={getSpecializationConfigs('insurance-management').find(spec => spec.key === '50-60')?.fundIds || []}
    specialization="50-60"
  />
  <LazyComparisonTable
    category="insurance-management"
    
    title={getSpecializationConfigs('insurance-management', 'קרנות ביטוח מנהלים').find(spec => spec.key === 'עד-50')?.title || "קרנות ביטוח מנהלים - עד גיל 50"}
    fundIds={getSpecializationConfigs('insurance-management').find(spec => spec.key === 'עד-50')?.fundIds || []}
    specialization="עד-50"
  />
</div>
</div>
        {/* 🏛️ קרנות פנסיה */}
        <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-2xl p-6 md:p-8 border border-red-200">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="p-2.5 md:p-3 bg-red-500 rounded-xl shadow-md">
              <Building className="h-5 w-5 md:h-6 md:w-6 text-white" />
            </div>
            <div className="text-right">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">קרנות פנסיה</h3>
              <p className="text-sm sm:text-base text-red-600 font-medium">פנסיה-נט • קצבאות וביטוח נכות</p>
            </div>
          </div>
          <div className="self-end md:self-auto">
            <button
              onClick={() => handleCategoryChange('pension-plans')}
              className="px-4 py-2 text-sm sm:text-base bg-red-600 hover:bg-red-700 text-white rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
            >
             צפה בכל הקרנות ←
            </button>
          </div>
        </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LazyComparisonTable
              category="pension-plans"
                
              title={getSpecializationConfigs('pension-plans', 'קרנות פנסיה').find(spec => spec.key === 'sp500')?.title || "קרנות פנסיה - S&P 500"}
              fundIds={getSpecializationConfigs('pension-plans').find(spec => spec.key === 'sp500')?.fundIds || []}
              specialization="sp500"
            />
            <LazyComparisonTable
              category="pension-plans"
               
              title={getSpecializationConfigs('pension-plans', 'קרנות פנסיה').find(spec => spec.key === 'עד-50')?.title || "קרנות פנסיה - עד גיל 50"}
              fundIds={getSpecializationConfigs('pension-plans').find(spec => spec.key === 'עד-50')?.fundIds || []}
              specialization="עד-50"
            />
          </div>
        </div>

        {/* 💝 תוכנית חיסכון לכל ילד */}
        <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-6 md:p-8 border border-pink-200">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="p-2.5 md:p-3 bg-pink-500 rounded-xl shadow-md">
              <Heart className="h-5 w-5 md:h-6 md:w-6 text-white" />
            </div>
            <div className="text-right">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">תוכנית חיסכון לכל ילד</h3>
              <p className="text-sm sm:text-base text-pink-600 font-medium">גמל-נט • חיסכון לעתיד הילדים</p>
            </div>
          </div>
          <div className="self-end md:self-auto">
            <button
              onClick={() => handleCategoryChange('child-savings')}
              className="px-4 py-2 text-sm sm:text-base bg-pink-600 hover:bg-pink-700 text-white rounded-xl font-semibold transition-all duration-300 shadow hover:shadow-md"
            >
               צפה בכל התוכניות ←
            </button>
          </div>
        </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LazyComparisonTable
              category="child-savings"
              
              title={getSpecializationConfigs('child-savings', 'תוכנית חיסכון לכל ילד').find(spec => spec.key === 'סיכון-מוגבר')?.title || "חיסכון לילד - סיכון מוגבר"}
              fundIds={getSpecializationConfigs('child-savings').find(spec => spec.key === 'סיכון-מוגבר')?.fundIds || []}
              specialization="סיכון-מוגבר"
            />
            <LazyComparisonTable
              category="child-savings"
            
              title={getSpecializationConfigs('child-savings', 'תוכנית חיסכון לכל ילד').find(spec => spec.key === 'סיכון-בינוני')?.title || "חיסכון לילד - סיכון בינוני"}
              fundIds={getSpecializationConfigs('child-savings').find(spec => spec.key === 'סיכון-בינוני')?.fundIds || []}
              specialization="סיכון-בינוני"
            />
          </div>
        </div>
      </div>
<RouteScannerCTA />
      {/* קריאה לפעולה */}
      <div className="mt-16 text-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
        <h3 className="text-2xl font-bold mb-4">מוכנים להשוות את כל המוצרים?</h3>
        <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
          בחרו קטגוריה מהכפתורים למעלה כדי לראות השוואה מפורטת עם עשרות טבלאות ומאות מוצרים בכל קטגוריה
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          {savingsCategories.slice(0, 10).map((category) => (
            <button
              key={category.id}
              onClick={() => handleCategoryChange(category.id)}
              className="px-6 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-xl font-semibold transition-all duration-300 hover:scale-105"
            >
              {category.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  </section>
)}
    </div>
  );
};

export default NewHomePage;